import { MapPin, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const Owners = () => (
  <section className="bg-paper py-24 sm:py-28" data-testid="owners-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <div className="grid items-center gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 rounded-[2rem] border border-royal/25" aria-hidden />
              <img
                src="/brand/owners.webp"
                alt="The owners of Oregon Tote Rentals — a locally owned Bend, Oregon family business"
                className="relative w-full rounded-[1.75rem] object-cover shadow-2xl shadow-slate-900/15"
                data-testid="owners-photo"
              />
              <span className="absolute -bottom-5 left-6 flex items-center gap-2 rounded-full bg-royal px-4 py-2 font-mono text-[10px] font-semibold uppercase tracking-[0.15em] text-white shadow-lg shadow-royal/30">
                <MapPin className="h-3.5 w-3.5" /> Locally owned · Bend, OR
              </span>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-royal">
              Meet your neighbors
            </p>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Locally owned,{" "}
              <span className="font-serif font-normal italic text-royal">family run.</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600">
              Oregon Tote Rentals is locally owned and operated right here in Central Oregon.
              We're the family behind the blue totes — every sanitizing cycle, every delivery
              route through Bend, Redmond, Sisters and Sunriver, and every pickup is handled by us
              personally, not a call center.
            </p>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-600">
              We started this because moving is hard enough without a mountain of cardboard.
              When you rent from us, you're supporting a local family — and when you call,
              you talk to the owners.
            </p>
            <a
              href="tel:+15414087019"
              data-testid="owners-call-link"
              className="mt-8 inline-flex items-center gap-2.5 rounded-full border border-slate-200 bg-white px-6 py-3.5 text-sm font-bold text-ink transition-all duration-200 hover:border-royal hover:text-royal hover:shadow-lg hover:shadow-royal/10"
            >
              <Phone className="h-4 w-4" /> (541) 408-7019 — talk to the owners
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);